import React from 'react';
import { createLazyPage } from '../createLazyPage';
import { AppRouteDefinition } from '../routeDefinition';

const AppointmentsCsnuPage = createLazyPage(
  () => import('@app/modules/csnu/pages/AppointmentsCsnuPage')
);

const CustomerAnalysisPage = createLazyPage(
  () => import('@app/modules/csnu/pages/CustomerAnalysisPage')
);

const ProcessingAnalysisPage = createLazyPage(
  () => import('@app/modules/csnu/pages/ProcessingAnalysisPage')
);

export const csnuRoutes: AppRouteDefinition[] = [
  {
    key: 'appointments-csnu',
    path: 'appointments-csnu',
    element: <AppointmentsCsnuPage />,
  },
  {
    key: 'appointments-csnu-analysis',
    path: 'appointments-csnu/appointments-analysis',
    element: <CustomerAnalysisPage />,
  },
  {
    key: 'processing-analysis',
    path: 'processing-analysis',
    element: <ProcessingAnalysisPage />,
  },
];
